import { mapActions, mapGetters, mapState } from 'vuex';
import Contract from '@/models/contract';
import { MODALS } from '@/components/app/app-modals/app-modals'

export default {
  props: {
    contract: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showMenu: false,
      selectedType: '',
    }
  },
  computed: {
    ...mapGetters('app', ['isLayoutDesktop', 'isLayoutMobile']),
    ...mapGetters('user', ['isLoggedIn']),
    ...mapState('trade', ['tradeOptions']),
    typesBuy() {
      return 'buy';
    },
    typesSell() {
      return 'sell';
    },
    types() {
      return [
        this.typesBuy,
        this.typesSell,
      ]
    },
    showOptionToggle() {
      return this.contractModel.mode && this.contractModel.mode === this.tradeOptions.operationValue;
    },
    tradeType() {
      switch (`${this.tradeOptions.operationType}_${this.tradeOptions.operationValue}`) {
        case 'buy_no': return 0;
        case 'buy_yes': return 1;
        case 'sell_no': return 2;
        case 'sell_yes': return 3;
        default: return -1;
      }
    },
    isYesType() {
      return this.tradeType === 1 || this.tradeType === 3;
    },
    yesNoText() {
      return this.isYesType ? 'YES' : 'NO';
    },
    contractModel() {
      return new Contract(this.contract);
    },
  },
  methods: {
    ...mapActions('trade', ['setTradeOptions', 'toggleTradeOperation']),
    ...mapActions('notifications', ['addSimple']),
    ...mapActions('popup', ['setCurrentPopup']),
    switchOperation(value) {
      if (value === this.selectedType) {
        return;
      }

      if (!this.showOptionToggle && !this.isLoggedIn) {
        this.setCurrentPopup(MODALS.LOGIN);
        return;
      }

      this.setTradeOptions({
        contractId: this.contract.contractId,
        operationType: value,
        operationValue: this.tradeOptions.operationValue,
      });
      this.showMenu = false
    },
    switchDirection(direction) {
      if (direction === this.yesNoText.toLowerCase()) return;
      if (direction === 'yes') {
        this.toggleTradeOperation('left');
      } else {
        this.toggleTradeOperation('right');
      }
    },
    onMenuToggle() {
      this.showMenu = !this.showMenu;
    },
    directionClassModifiers(direction) {
      return {
        'purchase-trade-type-switcher-sushi__direction': true,
        'purchase-trade-type-switcher-sushi__direction--selected': direction === this.yesNoText.toLowerCase(),
        'purchase-trade-type-switcher-sushi__direction--no': this.yesNoText.toLowerCase() === 'no',
      };
    },
    operationClassModifiers(operation) {
      return {
        'purchase-trade-type-switcher-sushi__operation': true,
        // 'purchase-trade-type-switcher-sushi__operation--not-available': !this.showOptionToggle && this.isLoggedIn,
        'purchase-trade-type-switcher-sushi__operation--selected': operation === this.selectedType.toLowerCase(),
      };
    },
    tradeOptionsHandler (value) {
      this.selectedType = value.operationType;
    },
    onClickOutside() {
      this.showMenu = false;
    }
  },
  watch: {
    tradeOptions: {
      handler: 'tradeOptionsHandler',
      immediate: true,
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/purchase/sushi/purchase-trade-type-switcher-sushi/purchase-trade-type-switcher-sushi.js